import { $config } from "@/tenant/config";

const routes = [
  {
    name: "support",
    path: "/support",
    beforeEnter: (to, from) => {
      window.location.href = $config.getExternalUrl(to.path);
    },
  },
  {
    name: "stem",
    path: "/stem",
    alias: "/VUE_APP_DOT_STEM_APP",
    meta: { auth: false },
    beforeEnter: () => window.location.replace(process.env["VUE_APP_DOT_STEM_APP"]),
  },
  {
    name: "explore",
    path: "/explore",
    alias: "/VUE_APP_DOT_EXPLORE_APP",
    meta: { auth: false },
    beforeEnter: () => window.location.replace(process.env["VUE_APP_DOT_EXPLORE_APP"]),
  },
];

const externalUrls = {
  local: {
    "/support": "support.dev-nls.apps-dotincorp.com",
    "/account": "account.dev-nls.apps-dotincorp.com",
  },
  dev: {
    "/support": "support.dev-nls.apps-dotincorp.com",
    "/account": "account.dev-nls.apps-dotincorp.com",
  },
  real: {
    "/support": "support.dotincorp.com",
    "/account": "account.dotincorp.com",
  },
};

export { routes as default, externalUrls };
